import useSWR, { mutate as globalMutate } from "swr";
import axios from "axios";
import { DOMAIN_API_HOST } from '../configs/main.js';

export const ADMIN_ME_KEY = `admin_${DOMAIN_API_HOST}/api/v1/me`;

export async function fetchAdminUser() {
  const token = localStorage.getItem("admin_token");
  if (!token) {
    throw new Error("No admin token");
  }
  const response = await axios.get(`${DOMAIN_API_HOST}/api/v1/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export function setAdminUserCache(user) {
  return globalMutate(ADMIN_ME_KEY, user, false);
}

export default function useAdminUser() {
  const token = typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;

  const { data, error, mutate } = useSWR(token ? ADMIN_ME_KEY : null, fetchAdminUser);
  const isLoading = token ? (!error && !data) : false;
  const loggedOut = Boolean(!isLoading && error);
  const role = data?.role;

  return {
    token,
    user: data,
    isLoading,
    loggedOut,
    role,
    mutate,
  };
}
